import { OepaUserAccount } from "@ohioepa/oepa-common-lib";

export const intLiveReloadAccount: OepaUserAccount = {
    loginName: 'aniamlar',
    accountID: 'aniamlar',
    firstName: 'Arunee',
    lastName: 'Niamlarb',
    corePersonID: {
      value: 2994
    },
    primaryEMailAddress: 'arunee.niamlarb@epa.ohio.gov',
    type: 'APPLICATION_PORTAL',
    roleList: [
      {
        name: 'StarsRoles',
        description: 'Stars User Role',
        privilegeList: [
          { type: 'RETRIEVE_REVENUE', name: 'Retrieve Revenue'}
        ]
      }
    ]
  }
